import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Dogs from './components/Dogs';
import SocialProof from './components/SocialProof';
import PortfolioHub from './components/PortfolioHub';
import { FeaturedTrailer, FeaturedTrailerTeaser } from './components/FeaturedTrailer';
import Contact from './components/Contact';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import AdminInbox from './components/AdminInbox';
import AdminLogin from './auth/AdminLogin';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { Toaster } from './components/ui/toaster';
import './App.css';

const SectionDivider = () => (
  <div className="section-divider py-2">
    <span className="glyph">&#9670;</span>
  </div>
);

const HomePage = () => (
  <>
    <Hero />
    <FeaturedTrailerTeaser />
    <SectionDivider />
    <About />
    <SectionDivider />
    <SocialProof />
    <SectionDivider />
    <FeaturedTrailer />
    <SectionDivider />
    <PortfolioHub />
    <SectionDivider />
    <Contact />
    <SectionDivider />
    <FAQ />
    <SectionDivider />
    <Dogs />
    <Footer />
  </>
);

const AdminGate = () => {
  const { admin } = useAuth();
  if (admin === null) {
    return (
      <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center" data-testid="admin-loading">
        <p className="text-[#E8E4DF]/40 text-sm" data-font="label">Loading…</p>
      </div>
    );
  }
  if (!admin) return <AdminLogin />;
  return <AdminInbox />;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App bg-[#0A0A0B] text-[#F0EDE8] min-h-screen">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/admin" element={<AdminGate />} />
            </Routes>
          </main>
          <Toaster />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
